import React, { useEffect, useState } from 'react'

import { Box, TextField, Typography } from '@mui/material'
import { useStyles } from '../styles'
import { useApi } from '../../../../hooks/useApi'
import { WorkOrder } from '../../../../interfaces'
import { ApiConfig } from '../../../../config/api'
import axios from 'axios'
import { LoadingButton } from '../../../../components/_EOS/Button/LoadingButton'
import { Status } from '../../../../hooks/useFetchState'
import { useUser } from '../../../../hooks/useUser'
import { StepProps } from '../../../../components/_WMS/Stepper'
import { eInventoryCheckSteps, SharedStateType } from '../../types'

interface ValidateInventoryWorkOrderProps extends StepProps<SharedStateType> {}

const getWorkOrder = (workOrderId: number, userId: number) => {
  const url = new URL(
    `${ApiConfig.InventoryCheckApi}/${workOrderId}/user/${userId}`
  )

  return axios.get(url.toString())
}

export const ValidateInventoryWorkOrder: React.FC<
  ValidateInventoryWorkOrderProps
> = ({ next, setSharedState, sharedState, goToStep }) => {
  const { state, callApi } = useApi<WorkOrder>()

  const user = useUser()

  useEffect(() => {
    if (user.userDataState) {
      setSharedState((prevState) => ({
        ...prevState,
        user: user.userDataState.userData
      }))
    }
  }, [user.userDataState])

  const requestGetWorkOrder = () => {
    if (inventoryCheckId) {
      callApi(
        getWorkOrder(
          inventoryCheckId,
          user?.userDataState.userData?.userId || 0
        )
      )
        .then((response: WorkOrder) => {
          setSharedState((prev) => ({
            ...prev,
            workOrderId: inventoryCheckId
          }))

          if (!response) {
            throw Error('WorkOrder no existe')
          }
        })
        .then(next)
        .catch((ex) => {
          setSharedState((prev) => ({
            ...prev,
            workOrderId: undefined,
            error: ex
          }))
          goToStep(eInventoryCheckSteps.Error)
        })
    }
  }

  const classes = useStyles()

  const [inventoryCheckId, setInventoryCheckId] = useState(
    sharedState.workOrderId
  )

  const handleValidateInventoryCheckOrder = (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault()

    requestGetWorkOrder()
  }
  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Typography variant='body1'>
          Operador {user?.userDataState.userData?.userAlias}
        </Typography>
      </Box>
      <Box className={classes.content}>
        <Box className={classes.formControl}>
          <form onSubmit={handleValidateInventoryCheckOrder}>
            <TextField
              autoFocus
              type='number'
              variant='outlined'
              label='Ingrese Id de Ciclico'
              value={inventoryCheckId}
              onChange={(e) => setInventoryCheckId(parseInt(e.target.value))}
            />
          </form>
          <LoadingButton
            loading={state.status === Status.Loading}
            variant='contained'
            color='primary'
            onClick={requestGetWorkOrder}
            fullWidth
            disabled={!inventoryCheckId}
          >
            Siguiente
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  )
}
